/**
 * Labstep
 *
 * @module components/ProtocolValue/Action/Menu
 * @desc Action Menu for ProtocolValue
 */

import ProtocolConditionActionCompareData from 'labstep-web/components/ProtocolCondition/Action/CompareData';
import { ProtocolValueActionDelete } from 'labstep-web/components/ProtocolValue/Action/Delete';
import { ProtocolValueActionView } from 'labstep-web/components/ProtocolValue/Action/View';
import { ActionMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';
import type { IProtocolValueActionMenuProps } from './types';

export enum Action {
  view = 'view',
  delete = 'delete',
  reporting = 'reporting',
}

export const ProtocolValueActionMenu: React.FC<
  IProtocolValueActionMenuProps
> = ({ protocolValue, type, actions = [] }) => {
  return (
    <ActionMenu
      type={type}
      dataCy="components/ProtocolValue/Action/Menu"
    >
      {actions.indexOf(Action.view) > -1 && (
        <ProtocolValueActionView protocolValue={protocolValue} />
      )}
      {actions.indexOf(Action.delete) > -1 && (
        <ProtocolValueActionDelete protocolValue={protocolValue} />
      )}
      {actions.indexOf(Action.reporting) > -1 && (
        <ProtocolConditionActionCompareData
          actionComponentType="option"
          protocolValue={protocolValue}
        />
      )}
    </ActionMenu>
  );
};

ProtocolValueActionMenu.defaultProps = {
  actions: [],
  type: 'icon',
};
